import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-gems-analytics',
  templateUrl: './gems-analytics.component.html',
  styleUrls: ['./gems-analytics.component.scss']
})
export class GemsAnalyticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
